import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaginationConfig } from '../data-table/data-table.component';

@Component({
  selector: 'app-data-pagination',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  templateUrl: './data-pagination.component.html',
  styleUrl: './data-pagination.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataPaginationComponent {
  @Input({ required: true }) paginationConfig!: PaginationConfig;
  @Input() isLoading = false;
  @Input() showPageSizeSelector = false;
  @Input() pageSizeOptions?: number[] = [5, 10, 25, 50, 100];
  @Output() pageChange = new EventEmitter<{ page: number }>();
  @Output() pageSizeChange = new EventEmitter<{ pageSize: number }>();
  get selectedPageSize(): number { return this.paginationConfig.pageSize; }
  get isFirstPage(): boolean { return this.paginationConfig.currentPage <= 1; }
  get isLastPage(): boolean { return this.paginationConfig.currentPage >= this.paginationConfig.totalPages; }
  get displayedRange(): { start: number; end: number } {
    const p = this.paginationConfig;
    return { start: p.totalCount ? (p.currentPage - 1) * p.pageSize + 1 : 0, end: Math.min(p.currentPage * p.pageSize, p.totalCount) };
  }
  previousPage(): void { if (!this.isLoading && !this.isFirstPage) this.pageChange.emit({ page: this.paginationConfig.currentPage - 1 }); }
  nextPage(): void { if (!this.isLoading && !this.isLastPage) this.pageChange.emit({ page: this.paginationConfig.currentPage + 1 }); }
  onPageSizeChange(event: Event): void {
    const size = Number((event.target as HTMLSelectElement).value);
    if (!this.isLoading && size > 0) this.pageSizeChange.emit({ pageSize: size });
  }
}
